import { FORECAST_KEY } from "constants/settings.constants";

import {
  isForecastQualifiedProperty,
  splitForecastQualification
} from "components/groupBy/helpers/qualifyForecastProperty";

import getCumPlusForecastTitle from "./getCumPlusForecastTitle";

// The forecast qualification a previous removeLabel took off this field, kept so the toggle can
// put back exactly what it removed. Only the marker is common to every source: EVA Research adds
// nothing after it, trumping adds the rescat, a named source adds source and rescat. Appending a
// bare marker to a property that still carried one of those suffixes produced
// `...TwelveMCalTimeCum.P+PDP.fcst`, which the service cannot resolve, so the chart came back
// empty.
const addLabel = (field) =>
  Object.assign({}, field, {
    // Guarded rather than appended blind: appending a marker to a property that already
    // carries one is the whole bug class here, and the title-based state machine below is the
    // only thing keeping it from happening. Two other places rewrite property without touching
    // title (updateForecastSourceToCurrentSchema, requalifyAxisForForecastTrumping), so the
    // guard closes the class instead of this one instance of it.
    property: isForecastQualifiedProperty(field.property)
      ? field.property
      : `${field.property}.${FORECAST_KEY}${field.forecastPropertySuffix ?? ""}`,
    // Spent: the qualification is back in the property, and holding a second copy invites the two
    // disagreeing after a re-pick.
    forecastPropertySuffix: undefined,
    title: getCumPlusForecastTitle(field.title, "", field.subgroup)
  });

const removeLabel = (field) => {
  const { base, qualification } = splitForecastQualification(field.property);
  return Object.assign({}, field, {
    property: base,
    forecastPropertySuffix: qualification,
    title: field.title.replace(" + Forecast", "")
  });
};

const toggleForecastLabels = (field, showForecastLabels) => {
  const copy = Object.assign({}, { ...field });
  const { group, title } = copy;

  if (group && group !== "Performance") return copy;

  const cumIndex = title.indexOf("Cum");
  if (cumIndex < 5) return copy;

  const hasForecastLabel = title.includes(" + Forecast");

  if (hasForecastLabel && showForecastLabels) return copy;
  if (hasForecastLabel && !showForecastLabels) return removeLabel(copy);
  if (!hasForecastLabel && showForecastLabels) return addLabel(copy);
  return copy;
};

export default toggleForecastLabels;
